<template>
  <div id="contenedor-listado-espesificacion-detalle-observacion">
    <template
      v-if="$apollo.queries.auditoriaInformeObservacionDetalleSeguimientos.loading">
      <v-skeleton-loader
        type="table-heading, table-thead, table-tbody">
      </v-skeleton-loader>
    </template>
    <template
      v-else>
      <v-data-table
        :headers="headers"
        :items="listado"
        hide-default-footer>
        <template v-slot:[`item.documento`]="{ item }">
          <v-btn icon color="red" class="mr-2" @click="loadPdf(item)">
            <v-icon>
              mdi-file-pdf-box
            </v-icon>
          </v-btn>
          <v-btn icon @click="descargarArchivo(item)">
            <v-icon>
              mdi-download
            </v-icon>
          </v-btn>
        </template>
        <template v-slot:[`item.acciones`]="{ item }">
          <v-btn
            v-if="idRespuestaDetalle"
            @click="integrarSeguimientoRespuestaDetalleDocumento(item)">
            Integrar
          </v-btn>
          <v-btn
            v-show="!soloLectura"
            icon
            @click="eliminarSeguimiento(item)">
            <v-icon>
              mdi-delete
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </template>
    <v-dialog v-model="mostrarVistaPrevia" max-width="800px">
      <v-card>
        <v-card-title>
          <span class="headline">Vista Previa del Documento</span>
          <v-spacer></v-spacer>
          <v-btn icon @click="mostrarVistaPrevia = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <div
            v-if="progresoDescarga < 100 && progresoDescarga > 0"
            style="height: 700px; overflow: auto; width: 100%;"
            class="grey lighten-3 text-center rounded d-flex justify-center align-center">
            <v-progress-circular
              :rotate="-90"
              :size="100"
              :width="15"
              :value="progresoDescarga"
              color="teal"
            >
              {{ progresoDescarga }}
            </v-progress-circular>
          </div>
          <VistaPreviaPdf v-if="pdfUrl" :rutaArchivo="pdfUrl" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import LISTADO_SEGUIMIENTO_DETALLE_OBSERVACION from '@/graphql/querys/administracion/auditorias/auditoriaInformeObservacionDetalleSeguimientos.gql';
import BORRAR_SEGUIMIENTO from '@/graphql/querys/administracion/auditorias/removerAuditoriaInformeObservacionDetalleSeguimiento.gql';
import AGREGAR_AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTO from '@/graphql/mutations/administracion/auditorias/respuestas/detalles/documentos/agregarAuditoriaInformeRespuestaDetalleDocumento.gql';
import mixInformes from '@/components/administracion/auditorias/informes/mixInformes';
import VistaPreviaPdf from '@/components/VistaPreviaPdf.vue';

export default {
  name: 'ListadoEspecificacionDetalleObservacion',
  mixins: [mixInformes],
  components: {
    VistaPreviaPdf,
  },
  props: {
    idDetalle: {
      type: String,
      required: true,
    },
    idRespuestaDetalle: {
      type: String,
      required: false,
    },
    soloLectura: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      mostrarVistaPrevia: false,
      pdfUrl: null,
      rutaArchivo: null,
      archivoDescarga: null,
      documento: {
        idAuditoriaInformeRespuestaDetalle: null,
        idAuditoriaInformeRespuestaDetalleSeguimiento: null,
        nombre: '',
        fileData: null,
      },
      headers: [
        { text: 'Especificación', value: 'fileData.name', sortable: false },
        {
          text: 'Documento', align: 'center', value: 'documento', sortable: false,
        },
        {
          text: '', align: 'right', value: 'acciones', sortable: false,
        },
      ],
    };
  },
  apollo: {
    auditoriaInformeObservacionDetalleSeguimientos: {
      query: LISTADO_SEGUIMIENTO_DETALLE_OBSERVACION,
      variables() {
        return {
          idAuditoriaInformeObservacionDetalle: this.idDetalle,
          tipo: 2, // Especificaciones
        };
      },
    },
  },
  methods: {
    async integrarSeguimientoRespuestaDetalleDocumento(seguimiento) {
      this.documento.idAuditoriaInformeRespuestaDetalle = this.idRespuestaDetalle;
      this.documento.idAuditoriaInformeRespuestaDetalleSeguimiento = seguimiento.id;
      this.documento.nombre = 'nombre';
      this.documento.fileData = seguimiento.fileData;

      this.mixEsCargando();

      await this.$apollo
        .mutate({
          mutation: AGREGAR_AUDITORIA_INFORME_RESPUESTA_DETALLE_DOCUMENTO,
          variables: {
            documento: this.documento,
          },
        })
        .then(() => {
          this.mixMensajeSuccess();
        })
        .catch((err) => {
          this.mixMensajeError(err);
        });
      this.mixEsCargando();

      await this.$apollo.queries.auditoriaInformeRespuestaDetalleDocumentos.refetch({
        idAuditoriaInformeRespuestaDetalle: this.idRespuestaDetalle,
      });
    },
    async eliminarSeguimiento(seguimiento) {
      this.mixEsCargando();

      await this.$apollo.mutate({
        mutation: BORRAR_SEGUIMIENTO,
        variables: {
          id: seguimiento.id,
        },
      }).then(async () => {
        await this.$apollo.queries.auditoriaInformeObservacionDetalleSeguimientos.refetch({
          idAuditoriaInformeObservacionDetalle: this.idDetalle,
        });
        this.mixMensajeSuccess();
        this.$emit('success');
      }).catch((err) => {
        this.mixMensajeError(err);
      });

      this.mixEsCargando();
    },
    async descargarArchivo(seguimiento) {
      let fileData = null;

      if (seguimiento.fileData) {
        fileData = seguimiento.fileData;
        fileData.publicKey = fileData.public_key;

        await this.mixDescargarArchivo(fileData, 'proyectoDocumentos');
      }
    },
    async loadPdf(detalle) {
      if (!detalle.fileData) return;

      this.mostrarVistaPrevia = true;

      const { data, err } = await this.mixGetPdf(detalle.fileData.public_key);

      if (err) {
        console.log(err);
      }

      this.pdfUrl = URL.createObjectURL(new Blob([data], {
        type: 'application/pdf',
      }));
    },
  },
  computed: {
    listado() {
      if (!this.auditoriaInformeObservacionDetalleSeguimientos) return [];

      return this.auditoriaInformeObservacionDetalleSeguimientos.map((seguimiento) => ({
        ...seguimiento,
        fileData: seguimiento.fileData ? JSON.parse(seguimiento.fileData) : null,
      }));
    },
  },
};
</script>

<style lang="scss">

</style>
